import React from "react";
import { useLocation } from "react-router-dom";
import OrderRequestReceipt from "../components/OrderRequestReceipt";

const OrderReceiptPage = () => {
  const location = useLocation();
  const order = location.state?.order;

  if (!order) {
    return <p>No order details available.</p>;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4 sm:p-6">
      <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 w-full max-w-3xl">
        <OrderRequestReceipt order={order} />
      </div>
    </div>
  );
};

export default OrderReceiptPage;
